import { Pipe, PipeTransform } from '@angular/core';
import { ProductStockViewModel } from '@models/api-search.models';

// Returns the amount of stores that has product in stock
@Pipe({
    name: 'storesWithStock',
    standalone: true
})
export class StoresWithStock implements PipeTransform {
    transform(storeStocks: ProductStockViewModel[] | undefined): number {
        if (!storeStocks?.length) {
            return 0;
        }
        return storeStocks.filter(store => store.stockQuantity > 0).length;
    }
}
